import Payment, { Context } from './Payment';

export { Context };
export default Payment;
